import { cloneDeep, isEqual, debounce, pick } from 'lodash'
export default {
  props: {
    // Пагинация
    pagination: {
      type: Object,
      default: () => {
        return {
          page: 1,
          rowsPerPage: 10,
          sortBy: null,
          descending: true
        }
      }
    },
    // Фильтры
    filters: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      items: [],
      currentFilters: {},
      currentPagination: {},
      loading: false,
      total: 0
    }
  },
  watch: {
    filters: {
      handler: 'resetFilters',
      immediate: true,
      deep: true
    },
    pagination: {
      handler: 'resetPagination',
      immediate: true,
      deep: true
    }
  },
  computed: {
    rowsPerPageItems() {
      return [5, 10, 25, 50, 100]
    },
    rowsPerPageText() {
      return 'Элементов на странице'
    },
    hasPrevItems() {
      const { page = 1 } = this.currentPagination
      return page > 1
    },
    hasNextItems() {
      const { page = 1, rowsPerPage = 10 } = this.currentPagination
      let itemsCount = page * rowsPerPage
      return this.total > itemsCount
    }
  },
  methods: {
    // Change sort
    changeSort(column) {
      let pagination = this.initPagination(this.currentPagination)
      pagination.page = 1
      if (pagination.sortBy === column) {
        pagination.descending = !pagination.descending
      } else {
        pagination.sortBy = column
        pagination.descending = false
      }
      this.updatePagination(pagination)
    },
    // Change current pagination
    resetPagination() {
      const pagination = this.initPagination(this.pagination)
      if (!isEqual(pagination, this.currentPagination)) {
        this.debouncedLoad()
      }
      this.currentPagination = pagination
    },
    // Change current filters
    resetFilters() {
      const filters = this.initFilters(this.filters)
      if (!isEqual(filters, this.currentFilters)) {
        this.debouncedLoad()
      }
      this.currentFilters = filters
    },
    // Init pagination
    initPagination(value) {
      let tmp = { page: 1, rowsPerPage: 5, sortBy: null, descending: false }
      return cloneDeep({ ...tmp, ...value })
    },
    // Init filters
    initFilters(value) {
      return cloneDeep({ ...{}, ...value })
    },
    // Refresh items
    refresh() {
      this.debouncedLoad()
    },
    // Debounced load items
    debouncedLoad: debounce(function() {
      this.loadItems()
    }, 100),
    loadItems() {},
    // Update pagination
    updatePagination(pagination) {
      this.$emit('update:pagination', this.initPagination(pagination))
    },
    // Update filters
    updateFilters(filters) {
      this.$emit('update:filters', this.initFilters(filters))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/list/index.js